export const EVENT_TYPES = {
    PRODUCT_VIEW: 'mtm.detailview',
    ADD_TO_CART: 'mtm.addtocart',
    CART_UPDATE: 'mtm.cartupdate',
    CART_TOTAL: 'mtm.cartTotal',
    ORDER_UPDATE: 'mtm.orderupdate',
    PURCHASE: 'mtm.purchase',
    GENERAL: 'mtm.general'
};
